import React from 'react';
import { withStyles } from '@material-ui/styles';
import cn from 'classnames';
import styles from '../styles';

const Text = withStyles(styles)(
  ({ classes, i, treeTrace, error, onChange, value, mode, isPassword, showLogs = false, isListItem = false }) => {
    const { field, label, direction, disabledOnEdit, disabled, validate } = i;

    // showLogs && console.log(value);
    const isDisabled = disabled || (disabledOnEdit && mode === 'EDIT');

    return (
      <div className={cn(classes.inputContainer)} style={Object.assign({}, isListItem && { marginTop: 0, marginBottom: 0 })}>
        <p
          style={{ marginBottom: 5, fontWeight: 400 }}
          className={cn(
            classes.inputLabel,
            // disabledOnEdit && mode === 'EDIT' && classes.disabledText,
            error && classes.textLabelError,
          )}
        >
          {label}: {!!error && error}
        </p>
        <input
          {...i}
          type={isPassword ? 'password' : 'text'}
          value={value || ''}
          disabled={isDisabled}
          className={cn(
            classes.input,
            classes.textInput,
            !!error && classes.textInputError,
            isDisabled && classes.disabledInput,
          )}
          style={{
            height: 27, // matching the Date input height
          }}
          onChange={evt => onChange(field, evt.target.value, treeTrace, i.onChange)}
        />
      </div>
    );
  },
);

export default Text;
